var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerIconAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48603 2 2 6.48604 2 12C2 17.514 6.48603 22 12 22C17.514 22 22 17.514 22 12C22 6.48604 17.514 2 12 2ZM12 3.5C16.7033 3.5 20.5 7.2967 20.5 12C20.5 16.7033 16.7033 20.5 12 20.5C7.29669 20.5 3.5 16.7033 3.5 12C3.5 7.2967 7.29669 3.5 12 3.5ZM11.7383 5.98926C11.5395 5.99236 11.3502 6.07422 11.2117 6.21686C11.0733 6.3595 10.9971 6.55125 11 6.75V12.75C11 12.9489 11.079 13.1397 11.2197 13.2803C11.3603 13.421 11.5511 13.5 11.75 13.5H15.75C15.8494 13.5014 15.9481 13.483 16.0403 13.446C16.1325 13.4089 16.2164 13.3539 16.2872 13.2841C16.358 13.2143 16.4142 13.1312 16.4526 13.0395C16.4909 12.9478 16.5107 12.8494 16.5107 12.75C16.5107 12.6506 16.4909 12.5522 16.4526 12.4605C16.4142 12.3688 16.358 12.2857 16.2872 12.2159C16.2164 12.1461 16.1325 12.0911 16.0403 12.054C15.9481 12.017 15.8494 11.9986 15.75 12H12.5V6.75C12.5014 6.64962 12.4827 6.54997 12.4449 6.45695C12.4071 6.36394 12.3511 6.27946 12.28 6.20852C12.209 6.13757 12.1245 6.08161 12.0314 6.04395C11.9383 6.00629 11.8387 5.98769 11.7383 5.98926Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIconAssessment);
export default __webpack_public_path__ + "static/media/timer-icon-assessment.bd99ade79b6e2124d2abd1bc22cccd21.svg";
export { ForwardRef as ReactComponent };